<template>
    <i class="top-logo"></i>
</template>

<script>
export default {
    name:'logo'
}
</script>

<style>

</style>
